import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function EditSettingBiaya() {
  const { id } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const ANGGOTA = 2;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [newData, setNewData] = useState([{
    nama_biaya: "",
    biaya: "",
    deskripsi: "",
  }]);
  const [biayaRp, setBiayaRp] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [dataSettingBiaya, setDataSettingBiaya] = useState();


  // CONTROLLER

  const fetchEditSettingBiaya = async (id) => {
    setIsLoading(true);
    await baseAPI
      .get(`/v1/csetting/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.dataSetting;
        setBiayaRp(parseFloat(data[0].biaya).toLocaleString('id-ID'));
        setDataSettingBiaya(data[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const updateSettingBiaya = async (id) => {

    Swal.fire({
      title: 'Do you want to update the data?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Update',
      denyButtonText: `Don't update`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(dataSettingBiaya));

        baseAPI
          .put(`/v1/csetting/${id}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Cost data has been updated.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil update ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Failed update the data.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchEditSettingBiaya(id);
          })
      } else if (result.isDenied) {
        Swal.fire('Data is not updated', '', 'info')
      }
    });

  }

  const handleFormat = (biaya) => {
    const numericValue = biaya.replace(/[^0-9]/g, '');
    let rupiahPlafond = parseFloat(numericValue).toLocaleString('id-ID');
    setBiayaRp(rupiahPlafond);
    setDataSettingBiaya({...dataSettingBiaya, biaya: numericValue});
  }

  useEffect(() => {
    setIsLoading(true);
    if (user.role === ADMIN) {
      fetchEditSettingBiaya(id);
    }
  }, [token]);
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Setting</Link> /{' '}
              <Link to='/setting/settingbiaya' style={{ color: '#333' }}>Setting Biaya</Link> /{' '}
              <Link to='#' style={{ color: '#333' }}>Edit Setting Biaya</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Edit Setting Biaya</b></p>
              </div>

              {/* Nama biaya */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Jenis Biaya
                </label>
                <input
                  defaultValue={dataSettingBiaya.nama_biaya}
                  className="form-control"
                  onChange={e => setDataSettingBiaya({...dataSettingBiaya, nama_biaya: e.target.value})}
                />
              </div>

              {/* Biaya */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Biaya (Rp.)
                </label>
                <input
                  value={biayaRp === "NaN" ? "Rp.0" : "Rp." + biayaRp}
                  className="form-control"
                  onChange={e => handleFormat(e.target.value)}
                />
              </div>

              {/* Deskripsi */}
              <div className='col-md-12 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Deskripsi
                </label>
                <textarea
                  defaultValue={dataSettingBiaya.deskripsi}
                  className="form-control"
                  onChange={e => setDataSettingBiaya({...dataSettingBiaya, deskripsi: e.target.value})}
                />
              </div>

              <div className='col-md-12'>
                <button
                  disabled={dataSettingBiaya.nama_biaya !== "" && dataSettingBiaya.biaya !== "" && dataSettingBiaya.deskripsi !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  style={{backgroundColor: '#CD5C08'}}
                  onClick={() => updateSettingBiaya(id)}
                >
                  Save
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default EditSettingBiaya;